import axios, { AxiosError, AxiosInstance } from 'axios';

import { API_V4_BASE_URL, BUILD_NUMBER } from '@/settings';

import { getTokens, logout, updateToken } from './token';

let refreshPromise: Promise<string> | null = null;

export const getRefreshToken = async () => {
  if (refreshPromise) return refreshPromise;
  refreshPromise = new Promise(async (resolve, reject) => {
    try {
      const { token, refreshToken } = getTokens();
      const { data } = await instanceRefreshToken.request({
        url: '/oauth/refresh',
        withCredentials: true,
        baseURL: API_V4_BASE_URL,
        method: 'post',
        headers: {
          RefreshToken: refreshToken,
          Authorization: `Bearer ${token}`,
          FrontVersion: BUILD_NUMBER || 'local'
        },
        params: {
          startWhen: 'requestFailed'
        }
      });
      updateToken(data?.data?.token.replace('Bearer ', '') || 'invalid');
      resolve(token);
    } catch (err) {
      const axiosError = err as AxiosError;
      console.log('axiosError', axiosError);

      if (axiosError?.isAxiosError) {
        const codesLogout = [401, 403, 404];
        codesLogout.includes(axiosError?.response?.status) && logout();
      }

      reject(err);
    } finally {
      refreshPromise = null;
    }
  });
  return refreshPromise;
};

const instanceRefreshToken: AxiosInstance = axios.create();
